module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/js/endpoints/splash/home/view.html
// module id = 1021
// module chunks = 0